/**
 * This page triggers an error, and is used for testing
 * the error handling and BugSnag reporting.
 */

export const CrashPage = (): JSX.Element => {
  throw new Error("This is a test error.");
};
